import React, { useContext } from 'react';
import { api } from '../../../api';
import { env } from '../../../env';
import { UploadOutlined } from '@ant-design/icons';
import { Upload, Button, Row, Col, Typography } from 'antd';
import {ModelContext} from "../../metadata/ModelSource";
import { ApplicationActionsContext } from '../../data/ApplicationDataSource';
import {ConfigContext} from 'portal-core/components/PortalApp';
import { GlobalStateContext } from '../../../context/GlobalStateProvider.jsx';

const { Dragger } = Upload;
const { Text } = Typography;

export function VehicleImageUpload({ label, ...restProps }) {
  const appModel = useContext(ModelContext);
  const actions = useContext(ApplicationActionsContext);
  const config = useContext(ConfigContext);
  let defaultTemplateId = appModel.data.typeCd === 'Application' ? config.branding.attachmentTemplates.application.vehicleUpload : config.branding.attachmentTemplates.quote.vehicleUpload;
  const templateId = defaultTemplateId ? defaultTemplateId : '';
  const { isMobile, isTablet} = useContext(GlobalStateContext);

  const apiCustomRequest = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append('image', file);
    const container = 'Application'
    const systemID = appModel.data.systemId;
    const attachTemplateURL = `/attachmentTemplates?container=${container}&containerRef=${systemID}`  ;
    const uploadResponseURL = env.fileUploadUrl;
    const templateResponse = await api.get(attachTemplateURL)
    const maxTemplateItems = Math.min(200, templateResponse.data.attachmentTemplateListItems.length);
    let selectedItem = templateResponse.data.attachmentTemplateListItems[0];
    for (let index = 0; index < maxTemplateItems; index++) {
      const tempItem = templateResponse.data.attachmentTemplateListItems[index];
      if (tempItem.id === templateId) {
        selectedItem = tempItem;
        break;
      }
    }
    const secondFileData = {
      id: file.uid,
      "templateId": selectedItem.id,
      "description": "Consumer Sales Portal document",
      filename: file.name
    };
    try {
      const uploadResponse = await api.post(uploadResponseURL, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (uploadResponse.status === 200) {
        onSuccess();
        appModel.notify({id: `uploadStatus-${file.name}`, message: `${file.name} file uploaded successfully`, type: 'success', overrideExisting: true})
        const bindResponse = await api.post(
          `/applications/${systemID}/documents`,
          secondFileData
        );
        if(bindResponse.status === 201 || bindResponse.status === 200) {
          actions.pullApplication();
        }
      } else if (uploadResponse.status === 'error') {
        throw new Error('Upload response returned error');
      }
    } catch (err) {
      appModel.notify({id: `uploadStatus-${file.name}`, message: `${file.name} file upload failed.`, type: 'error', overrideExisting: true})
      console.error('err', err);
      onError();
    }
  };

  const props = {
    name: 'image',
    //multiple is only supported on IE10+
    multiple: true,
    customRequest: (...args) => apiCustomRequest(...args),
    showUploadList: {
      showDownloadIcon: false
    }
  };

  return (
    <Row>
      <Col span={isMobile? 18:isTablet ? 24 : 4}
         style={{ marginLeft : '-2px', paddingTop: '10px'}}>
          <Text>{label}</Text>
      </Col>
      <Col span={isMobile? 18:isTablet? 24 :12} style ={{ marginLeft: isMobile ?'15%':'',paddingTop: isMobile ?  '10px':''}}>
        <Dragger {...props}>
          <Button>
            <UploadOutlined /> Upload Files
          </Button>
        </Dragger>
      </Col>
    </Row>
  );
}
